/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FormRegisterAliases {
  FIELD_0 = 'field-0',
  FORM_0 = 'form-0',
  INPUT_0 = 'input-0',
  PANEL_0 = 'panel-0',
}
export { FormRegisterAliases };
